export default "__VITE_ASSET__D$A6Q2wQ__"